export default __webpack_public_path__ + "static/media/ss_b.c7190570.wav";